module.exports = __webpack_public_path__ + "media/packs/static/fonts/circular-std/medium-e39d4081b339f42a2a55913a22dcfd15.woff";